// src/components/ProtectedOwnerRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedOwnerRoute = ({ children }) => {
  let user = null;

  try {
    const stored = localStorage.getItem("user");
    if (stored) {
      user = JSON.parse(stored);
    }
  } catch (err) {
    console.error("Invalid user data in localStorage:", err);
  }

  //. 1. Not logged in → redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  //. 2. Check for owner role (case-insensitive)
  const role = user.role?.toLowerCase?.() || "";

  if (role !== "owner") {
    alert("Access denied! Only property owners can list properties.");
    return <Navigate to="/" replace />;
  }

  //. 3. Valid owner → allow access
  return children;
};

export default ProtectedOwnerRoute;
